export const TRACKING_EVENT_PERSONALIZATION = {
	OPEN_ITINERARY_PANEL: 'open_itinerary_panel',
	APPLY_SEARCH_RESULTS: 'apply_search_results',
	INITIAL_SEARCH_RESULTS: 'initial_search_results',
};

export const CRUISING_CODES = ['ASE', 'CRU'];

export const FILTERS = ['search', 'sort', 'qualifiers'];

export const SESSION_KEY_CRUISE_RECOMMENDATION_ID = 'cruiseRecommendationId';

export const EMPTY_CRUISE_RECOMMENDATION_ID = 'no_model';
